import React, {useState} from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  Box,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { makeStyles } from '@mui/styles';
import { useLocation, useNavigate } from "react-router-dom";
import Page from "../../component/Page/Page";
import Textfield from "../../component/DarkMode/Textfield";
import Buttons from "../../component/DarkMode/Button";
import { RegisterService } from "../../_services/register";
import TermsAndConditionAlert from "../../component/AlertModel/TermsAndCondition";
import SnackBar from "../../component/SnackBar/SnackBar";
import CircularProgress from "@mui/material/CircularProgress";
import Header from "../../component/DarkMode/Header";
import Cookies from "universal-cookie";
import { setToken, loginSuccess } from "../../store/bugs";
import { loginService } from "../../_services/login";
import { connect } from "react-redux";
import Notification from "../../component/AlertModel/Notification";

const useStyles = makeStyles((theme) => ({
  boxcontainer: {
    height: "100vh",
    background: "#0d0d0d",
    position:'relative'
  },
  verifyText: {
    padding: "4px",
    color: "white",
    left: "calc(50% - 173px/2 - 77.5px)",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "20px",
    lineHeight: "30px",
  },
 
  verfySubTexts: {
    margin:"8px 0 !important",
    padding: "0 2px",
    color: "#fff",
    left: "16px",
    top: "135px",
    fontFamily: "Rubik !important",
    fontStyle: "normal !important",
    fontWeight: "400 !important",
    fontSize: "12px !important",
    lineHeight: "18px !important",
    letterSpacing:"-0.5px !important"
  },
  loader:{
    color: "white !important" ,
    width:'25px !important',
    height:'25px !important',
   }

}));

const CompanyDetails = (props) => {
  const classes = useStyles();
  const location = useLocation()
  const navigate = useNavigate()
  const cookies = new Cookies();

  const [valueColor, setValueColor] = useState();
  const [openTandC, setOpenTandC] = useState(false)
  const [open, setOpen] = React.useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState("");
  const [severity, setSeverity] = React.useState("");
  const [submit, setSubmit] = useState(false);

  const closemodel = () => {
    setOpenTandC(false)
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleOnSubmit = (values) => {
    setSubmit(true);
    const  verifyRegisterData = {
    user_type: "COMPANY",
    company_name: values.companyName,
    company_registration_no: values.regNo,
    email:location!=undefined ? location.state != undefined? location.state.email  : null : null,
    mobile_number: location!=undefined ? location.state != undefined? location.state.mobile  : null : null,
    created_user_id: location!=undefined ? location.state != undefined? location.state.userId  : null : null,
    country_code: "+91",
    first_name:"",
    last_name:""
    };
     RegisterService.verifyRegisterData(verifyRegisterData).then((res) => {
      setSubmit(false);
       if(res.data.message === "UPDATED_USER_PUBLIC_DETAILS"){
        props.setToken({ token: res.data.Jwttoken.token });
        cookies.set("token", res.data.Jwttoken.token, {
          path: "/",
          expires: new Date(
            new Date().getTime() + 60 * 60 * 1000 * 24 * 180
          ),
        });
        localStorage.clear()
        setUserInfo();
        setTimeout(() => {
        navigate("/home")
        }, 1000)
      }else{
        setSeverity("error");
        setSnackbarTitle("Something went wrong");
        setOpen(true);
      }
     })
     .catch(()=>{
      setSubmit(false);
      setSeverity("error");
      setSnackbarTitle("Something went wrong");
      setOpen(true);
     })
    }

    const setUserInfo = () => {
      loginService.getLoggedInUserInfo().then(async (res) => {
        if (res) {
          if (res.status === 200) {
            const auth = { loggedIn: true, user: res.data };
            props.loginSuccess({ auth: auth });
            // setUserData(res.data);
          }
        } else {
          setSeverity("error");
          setSnackbarTitle("Unable to connect the server, please try again");
          setOpen(true);
        }
      });
    };

    const handleError = (value1,value2) => {
      if ((value1.trim() === "")||(value1.trim() === "") ) {
        setValueColor(2);
      }
      else {
        setValueColor(0);
      }
    };

    function capitalize(str) {
      return str.toLowerCase().split(' ').map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }).join(' ');
    }
  
  return (
    <>
      <Page>
        <Box className={classes.boxcontainer}>
          <Notification  snackbarTitle={snackbarTitle} open={open} setOpen={setOpen} type={severity} />
          <Header/>  

          <Container >
          <Formik
              initialValues={{
                companyName: "",
                regNo: "",
              }}
              validationSchema={Yup.object().shape({
                companyName: Yup.string().required("Company name required"),
                regNo: Yup.string().required("Company register number name required")
              })}
              onSubmit={ (values) => {
                handleOnSubmit(values)
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                setFieldValue,
                isSubmitting,
                touched,
                values,
              }) => (
                <form onSubmit={handleSubmit}  autoComplete="off">
            <Grid container className={classes.container}>
              <Grid container  direction="column">
                <Textfield 
                 valueColor={(touched.companyName && errors.companyName) && values.companyName
                  ? 2
                  : values.companyName
                  ? 1
                  : null || valueColor}
                name="companyName"
                id="companyName"
                value={values.companyName}
                onChange={(e)=>{
                   setFieldValue("companyName", capitalize(e.target.value))
                   setOpen(false)
                }} 
                placeholder={"Company Name"} />
                <Textfield
                 valueColor={ (touched.regNo && errors.regNo) && values.regNo
                  ? 2
                  : values.regNo
                  ? 1
                  : null || valueColor}
                 name="regNo"
                 id="regNo"
                 value={values.regNo}
                 onChange={(e)=>{
                  setFieldValue("regNo",e.target.value)
                  setOpen(false)
               }} 
                placeholder={"Company Registration Number"}  />
                <Grid>
                  <Typography className={classes.verfySubTexts}>
                    By proceeding, I accept Unlistedkart’s{" "}
                    <a
                      onClick={()=>{ navigate('/termsandcondition',{
                        replace: true,
                        state: location != undefined ? {...location.state, type:"company"} : null,
                      })}}
                      style={{
                        textDecoration: "underline",
                        color: "#8264E5",
                      }}
                    >
                      T&C & Privacy Policy
                    </a>
                  </Typography>
                </Grid>
              </Grid>

              <Grid style={{ margin: " 10% auto" }}>
            
                <Buttons
                   handleError={handleError}
                   value1={values.companyName}
                   value2={values.regNo}
                   type="submit"
                  value={ "SIGN UP"}
                  animation={submit} />
                          
              </Grid>
            </Grid>
              </form>
              )}
            </Formik>
          </Container>
        </Box>
      </Page>
    </>
  );
};

const dispatchToProps = (dispatch) => ({
  setToken: (token) => dispatch(setToken(token)),
  loginSuccess: (auth) => dispatch(loginSuccess(auth)),
});

export default connect(null, dispatchToProps)(CompanyDetails);
